import React, { createContext, useState } from "react";

export const exportContext = createContext();

export default function ExportDataContext({ children }) {
  let [exportedDataHeader, setExportedDataHeader] = useState([]);
  let [exportedDataBody, setExportedDataBody] = useState([]);
  let [fileName, setFileName] = useState("");
  let [exportIds, setExportIds] = useState([]);
  let [startDateE, setStartDateE] = useState("");
  let [endDateE, setEndDateE] = useState("");
  let [filters, setFilters] = useState("");
  return (
    <>
      <exportContext.Provider
        value={{
          exportedDataHeader,
          setExportedDataHeader,
          exportedDataBody,
          setExportedDataBody,
          fileName,
          setFileName,
          exportIds,
          setExportIds,
          startDateE,
          setStartDateE,
          endDateE,
          setEndDateE,
          filters,
          setFilters,
        }}
      >
        {children}
      </exportContext.Provider>
    </>
  );
}
